<template>
  <div v-if="element" :class="`element-wrapper ${element.compData.type}-theme-${element.compData.styleId}`" :style="{...getStyles(element.compData.styles),
    width: element.width + 'px',
    height: element.height + 'px',}">
    <div class="swiper">
      <swiper class="swiper-container" :options="swiperOption" ref="mySwiper" @click-slide="handleClick" @ready="handleSwiperReadied">
        <swiper-slide v-for="(item, index) in element.compData.menus" :key="index">
          <div class="swiper-item" :style="'background-image:url(' + (isAbsoluteUrl(item.imgSrc) ? item.imgSrc : handleRepairePublicPrefix(item.imgSrc)) + ');'"></div>
          <span :class="['des', { hide: !element.compData.desHide }]">{{ item.des }}</span>
        </swiper-slide>
        <div :class="{'pagination-active': !element.compData.desHide}" slot="pagination">
          <div class="swiper-pagination"></div>
        </div>
        <div :class="['swiper-button-prev', {hide: element.compData.navBtnHide}]" slot="button-prev"></div>
        <div :class="['swiper-button-next', {hide: element.compData.navBtnHide}]" slot="button-next"></div>
      </swiper>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import { handleRepairePublicPrefix } from '@/util'
export default {
  name: "CompSwiper",
  props: {
    element: {
      type: Object,
      default: null,
      require: true,
    },
  },
  components: {
    Swiper,
    SwiperSlide,
  },
  data: () => {
    return {
      loading: true,
      handleRepairePublicPrefix
    };
  },
  computed: {
    plugin: function () {
      return this.$getPlugin(this.element.id);
    },
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
    swiperOption() {
      return this.element.compData.swiperOption;
    },
  },
  mounted() {
    setTimeout(() => {
      this.loading = false;
    }, 0);
  },
  methods: {
    handleClick(index, reallyIndex) {
      const item = this.element.compData.menus[reallyIndex] || null;
      item &&
        this.$blueMap.trigger({
          nodeType: "plugin",
          pluginId: this.plugin.id,
          dataKey: "onclick",
          eventData: {
            value: item,
            data: this.plugin,
            event: null,
          },
        });
    },
    // 默认图片内容加载完成，代替mounted触发trigger
    handleSwiperReadied(swiper) {
      this.$blueMap.trigger({
        nodeType: "plugin",
        pluginId: this.element.id,
        dataKey: "onmounted",
        eventData: {
          value: null,
          data: this.plugin,
          event: null,
        },
      });
    },
    isAbsoluteUrl(url){
      return /^[a-z][a-z0-9+.-]*:/.test(url)
    },
    getStyles(styles) {
      if (!styles) return;
      const res = {};
      Object.keys(styles).forEach((item) => {
        res[`--${item}`] =
          typeof styles[item] === "number" ? styles[item] + "px" : styles[item];
      });
      return Object.assign(res, {
        opacity: this.element["opacity"] / 100,
        "--fontSize": this.element["fontSize"] + "px",
        "--fontFamily": this.element["fontFamily"],
        "--fontColor": this.element["color"],
      });
    },
  },
};
</script>

<style lang='less' scoped>
.element-wrapper {
  width: 100%;
  height: 100%;
}
.swiper {
  width: 100%;
  height: 100%;
}
/deep/ .swiper-container {
  width: 100%;
  height: 100%;
}
/deep/ .swiper-slide {
  font-size: 36px;
  font-weight: 500;
  position: relative;
  span.des {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    padding: 10px 15px;
    background: rgba(0, 0, 0, 0.4);
    font-size: var(--fontSize);
    font-family: var(--fontFamily) !important;
    color: var(--fontColor);
    &.hide {
      display: none;
    }
  }
  .swiper-item {
    width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
  }
}
/deep/ .swiper-button-prev,
.swiper-button-next {
  &.hide {
    display: none;
  }
}
/deep/ .swiper-pagination {
  bottom: 10px;
  left: 50%;
  transform: translate(-50%, 0);
  .swiper-pagination-bullet {
    margin: 0 3px;
  }
}
.pagination-active .swiper-pagination {
  bottom: 50px;
}
</style>
